<eds-panel theme="primary" edsSpacing="xxl" *ngIf="profile || biosProfile">
  <div edsGrid>
    <!-- breadcrumbs  area -->
    <eds-breadcrumbs [items]="breadcrumbItems" theme="primary">
    </eds-breadcrumbs>
    <div class="container container--wide" edsPadding edsPaddingTop="md">
      <!-- portfolio name -->
      <div edsRow>
        <div edsCol>
          <eds-title
            size="h1"
            edsSpacing="sm"
            [level]="1"
            [isLight]="true"
            [title]="profile?.fullName || biosProfile?.displayName"
          ></eds-title>
        </div>
      </div>
      <div edsRow>
        <div edsCol>
          <eds-title
            size="h5"
            edsSpacing="xl"
            [isLight]="true"
            [title]="profile?.overview || biosProfile?.description"
          ></eds-title>
        </div>
      </div>
    </div>
  </div>
</eds-panel>

<!-- Potfolio Overview -->
<section edsGrid edsSpacing="xxl" *ngIf="profile || biosProfile">
  <div class="container container--wide">
    <!-- Summary -->
    <div
      edsRow
      *ngIf="profile?.location || profile?.tenure || biosProfile?.location"
    >
      <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '12' }">
        <eds-section-header theme="primary" size="h4--reg" edsSpacing="lg">
          {{ summaryLabel }}
        </eds-section-header>
      </div>
    </div>
    <!-- Summary data -->
    <div edsRow edsSpacing="lg">
      <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '12' }">
        <eds-panel
          theme="light"
          [hasPadding]="true"
          [hasBorders]="true"
          *ngIf="profile?.location || profile?.tenure || biosProfile?.location"
        >
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '5' }">
              <div
                edsFlexbox
                flexDirection="row"
                justifyContent="space-between"
                *ngIf="profile?.location || biosProfile?.location"
              >
                <p edsSpacing="sm">{{ locationLabel }}:</p>
                <p
                  edsSpacing="sm"
                  class="bold"
                  edsPadding
                  [edsPaddingRight]="(isHandheld$ | async) ? 'none' : 'lg'"
                >
                  {{ profile?.location || biosProfile?.location }}
                </p>
              </div>
            </div>
            <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '5' }">
              <div
                edsFlexbox
                flexDirection="row"
                justifyContent="space-between"
                *ngIf="profile?.tenure"
              >
                <p
                  edsPadding
                  [edsPaddingLeft]="(isHandheld$ | async) ? 'none' : 'lg'"
                  edsSpacing="sm"
                >
                  {{ tenureLabel }}:
                </p>
                <p edsSpacing="sm" class="bold">{{ profile.tenure }}</p>
              </div>
            </div>
          </div>
        </eds-panel>
      </div>
    </div>
    <!-- Summary content -->
    <div
      edsRow
      edsFlexbox
      justifyContent="space-between"
      flexDirection="row"
      edsSpacing="lg"
    >
      <div
        edsSpacing="xl"
        edsCol
        [columnNumbers]="{ s: '4', m: '8', l: '4' }"
        *ngIf="profileImage || biosProfile?.webImage"
      >
        <eds-image
          [imgSrc]="profileImage || biosProfile?.webImage"
          altText="profile image"
          className="img--full-width"
        >
        </eds-image>
      </div>
      <div
        *ngIf="profile?.content"
        edsCol
        [columnNumbers]="{ s: '4', m: '8', l: '6' }"
        [innerHTML]="profile?.content?.value || profile?.content"
      ></div>
      <div
        *ngIf="biosProfile"
        edsCol
        [columnNumbers]="{ s: '4', m: '8', l: '6' }"
      >
        <p *ngIf="biosProfile?.text1">{{ biosProfile?.text1 }}</p>
        <p *ngIf="biosProfile?.text2">{{ biosProfile?.text2 }}</p>
        <p *ngIf="biosProfile?.text3">{{ biosProfile?.text3 }}</p>
        <p *ngIf="biosProfile?.text4">{{ biosProfile?.text4 }}</p>
      </div>
    </div>
  </div>
</section>
